module.exports = __webpack_public_path__ + "static/media/nodiscount.668856a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nodiscount.png
// module id = 207
// module chunks = 6